<script setup>
import {computed} from "vue";
import {usePage} from "@inertiajs/vue3";
import {useStore} from "vuex";
import SidebarLogo from "@/components/Dashboard/Sidebar/Logo.vue";
import SidebarMenu from "@/components/Dashboard/Sidebar/Menu.vue";

const store = useStore()

const user = computed(() => usePage().props.user);
const sidebarExpanded = computed(() => store.getters["sidebar/sidebarExpanded"])
const fullSidebar = computed(() => sidebarExpanded.value ?? true)

const toggleSidebar = () => store.dispatch('sidebar/toggleSidebar')
</script>
<template>
  <nav class="sidebar" id="sidebarNavPanel" :class="{ active: fullSidebar }">
    <div class="navbar-brand nav_brand">
      <sidebar-logo :user="user"/>
      <div class="nav_toggle label" :class="{ active: !fullSidebar }" @click="toggleSidebar">
        <span></span>
      </div>
    </div>

    <sidebar-menu :user="user"/>
  </nav>
</template>
